
import router from '@/router'
import { message } from 'ant-design-vue'
import { defineComponent, onMounted, ref } from 'vue'
import {
  getCategoryList,
  getChildList,
  getArticleList,
  articleDetail
} from '../api/api'
export default defineComponent({
  name: 'ListView',
  components: {},
  setup() {
    const routerPath = ref<any>([])
    const leftMenu = ref<any>([{ categoryName: '' }])
    const rightMenu = ref<any>([])
    const currentMenu = ref(0) // 当前菜单
    const currentPage = ref(1) // 当前页数
    const pageSize = ref(10)
    const total = ref(0)
    const isShowArticle = ref(false)
    const articleObj = ref<any>({})
    const bgUrl = ref('') // 背景图

    onMounted(() => {
      const parentCode = router.currentRoute.value.params.id
      if (parentCode === 'about' || parentCode === 'recruit') {
        isShowArticle.value = true
      }
      getCategoryList().then((res: any) => {

        if (res && res.length > 0) {
          res.forEach((item: any) => {
            if (item.categoryCode === 'product') {
              console.log('判断成立');
              
              bgUrl.value = item.image
            }
          })
        }
      })

      getChildList({ parentCode: parentCode }).then((res: any) => {
        leftMenu.value = res
        routerPath.value = res[0].treeNames.split('/')
        getArticleList({
          categoryCode: leftMenu.value[0].categoryCode,
          pageNo: currentPage.value,
          pageSize: pageSize.value
        }).then((res1: any) => {
          if (res1 && res1.list.length > 0) {
            total.value = res1.count
            rightMenu.value = res1.list
            articleDetail({ code: parentCode, id: res1.list[0].id }).then(
              (res2: any) => {
                articleObj.value = res2
              }
            )
          }
        })
      })
    })
    // 获取文章列表
    function changeMenu(index: number) {
      currentMenu.value = index
      routerPath.value[1] = leftMenu.value[index].categoryName
      currentPage.value = 1
      getArticleList({
        categoryCode: leftMenu.value[index].categoryCode,
        pageNo: currentPage.value,
        pageSize: pageSize.value
      }).then((res: any) => {
        if (res && res.list.length > 0) {
          total.value = res.count
          rightMenu.value = res.list
          articleDetail({
            code: router.currentRoute.value.params.id,
            id: res.list[0].id
          }).then((res2: any) => {
            articleObj.value = res2
          })
        } else {
          total.value = 0
          rightMenu.value = []
          articleObj.value = {}
        }
      })
    }
    // 切换页码
    function handleChangePage() {
      getArticleList({
        categoryCode: leftMenu.value[currentMenu.value].categoryCode,
        pageNo: currentPage.value,
        pageSize: pageSize.value
      }).then((res: any) => {
        if (res && res.list.length > 0) {
          total.value = res.count
          rightMenu.value = res.list
        } else {
          total.value = 0
          rightMenu.value = []
        }
      })
    }
    // 跳转到文章详情
    function toArticle(id: number) {
      router.push({
        path: '/article',
        query: { code: router.currentRoute.value.params.id, id: id }
      })
    }
    return {
      leftMenu,
      rightMenu,
      changeMenu,
      currentMenu,
      currentPage,
      pageSize,
      total,
      routerPath,
      handleChangePage,
      isShowArticle,
      articleObj,
      toArticle,
      bgUrl
    }
  }
})
